import { UserBadgeEntry } from 'interfaces/badge.interface';
import { BADGES } from './endpoint-urls';
import http from './http-service';


export const getUserBadgeEntries = async (): Promise<UserBadgeEntry[]> => {
  const response = await http.get(BADGES);
  return Array.isArray(response.data) ? response.data : [];
};

export const updateUserBadgeEntry = async (
  id: string,
  payload: { display_confetti: boolean , user_notified: boolean }
): Promise<UserBadgeEntry> => {
  const response = await http.put(`${BADGES}/${id}`, payload);
  return response.data;
};
